import { showLoading, hideLoading } from 'react-redux-loading'
import { saveAnswer } from '../utils/api'

export const RECEIVE_QUESTIONS = 'RECEIVE_QUESTIONS'
export const SAVE_QUESTION_ANSWER = 'SAVE_QUESTION_ANSWER'

export function receiveQuestions (questions) {
	return {
		type: RECEIVE_QUESTIONS,
		questions
	}
}

function saveQuestionAnswer (id, answer) {
	return {
		type: SAVE_QUESTION_ANSWER,
		id,
		answer
	}
}

export function handleSaveQuestionAnswer (id, answer) {
	return (dispatch, getState) => {
		dispatch(showLoading())

		return saveAnswer(id, answer)
			.then(() => {
				dispatch(saveQuestionAnswer(id, answer))
			})
			.then(() => dispatch(hideLoading()))
	}
}


// WEBPACK FOOTER //
// ./src/actions/questions.js